import React from 'react'
import Banner from '../Banner/Banner'

const Home = () => {
  return (
    <section>
        <Banner></Banner>
    </section>
  )
}

export default Home